var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('IconButton',{attrs:{"disabled":_vm.disabled,"iconClass":"delete-icon","tooltip":_vm.tooltip},on:{"btn-clicked":function($event){return _vm.$emit('clicked')},"clicked-stop":function($event){return _vm.$emit('clicked-stop')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }